const BackButton = () => {
    return (
        <div style={{ textAlign: "left" }}>
            <button
                onClick={() => window.history.back()}
                style={{
                    fontSize: "1rem",
                    padding: ".5rem 1rem",
                    border: "1px solid #ccc",
                    backgroundColor: "#dbffdb",
                    borderRadius: ".5rem",
                    width: "5rem",
                    marginTop: "1%",
                }}
            >
                戻る
            </button>
        </div>
    );
};

export default BackButton;
